/**
* @Description 文件功能说明：参数配置组件
* @Author CC
* @Time 2020/6/4
**/

/* HTML */
<template>
    <!-- table start -->
    <div class="table-item-box _padding-l-none" style="padding: 10px;">
        <div style="text-align: left; display:none;">
            <!--padding-left: 5px;-->
          <span style="font-size: 14px">查询条件：</span>
            <el-input type="text" placeholder="请输入参数名称" clearable v-model="searchForm.keywords" style="width: 300px;text-align: left; margin-right: 10px;">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="getParamInfo"></i>
            </el-input>
        </div>

        <el-table
            :data="tableData"
            :stripe="stripe"
            style="width: 100%;height: 100%;"
            class="table"
            @cell-click="cellEdit">

            <el-table-column prop="paramName" label="参数名称" min-width="200px">
                <template slot-scope="scope">
            		<span style="white-space: nowrap;" :title="scope.row.paramName">{{scope.row.paramName}}</span>
            	</template>
            </el-table-column>
            <el-table-column prop="paramStatus" label="参数状态" min-width="120px">
                <template slot-scope="scope">
                    <span v-if="scope.row.paramStatus==2">可读写</span>
                    <span v-else>只读</span>
                </template>
            </el-table-column>
            <el-table-column prop="paramType" label="数据类型" min-width="120px"></el-table-column>
            <el-table-column label="参数值" prop="paramValue" min-width="120px" :render-header="renderHeader">
                <template slot-scope="{row,$index}">
                    <el-switch v-if="row.paramType == 'Boolean'"
                        size="mini"
                        class="switchStyle"
                        v-model="row.paramValue"
                        :active-value="'true'"
                        :inactive-value="'false'"
                        active-color="#00A854"
                        active-text="开启"
                        inactive-color="gray"
                        inactive-text="关闭"
                        @change="changeParamValue(row, $index)">
                    </el-switch>
                    <el-input ref="paramValue" v-else-if="row.seen"
                              v-model="row.paramValue"
                              @blur="loseFocus(row)">
                    </el-input>
                    <span v-else>{{row.paramValue}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="paramUnit" label="单位" min-width="120px"></el-table-column>
            <el-table-column prop="paramExplain" label="参数说明" min-width="300px">
                <template slot-scope="scope">
            		<span style="white-space: nowrap;" :title="scope.row.paramExplain">{{scope.row.paramExplain}}</span>
            	</template>
            </el-table-column>

        </el-table>

    </div>
    <!-- table end -->
</template>

/* JS */
<script>
    import SystemParam from '@/request/api-param'

    export default {
        /*
         * 组件名
         */
        name: "ParamConfig",
        /**
         * 数据定义
         */
        data() {
            return {
                screenHeight: window.innerHeight,
                /* table */
                stripe:true,//是否为斑马纹 table
                // 表格数据集合
                tableData: [],
                // 表格行定义
                dialogTbItem: {
                    dialogFormVisible: false,
                    // 规则定义
                    ruleForm: {
                        paramName: '',
                        paramType: '',
                        paramUnit: '',
                        paramStatus: '',
                        paramValue: '',
                        paramExplain: ''
                    },
                    // form定义
                    restForm: {
                        paramName: '',
                        paramType: '',
                        paramUnit: '',
                        paramStatus: '',
                        paramValue: '',
                        paramExplain: ''
                    },
                    rules: {}
                },
                // 查询定义
                searchForm: {
                    keywords: ''
                }
            }
        },
        /**
         * 初始化创建
         */
        created() {
            // 获取参数列表
            this.getParamInfo();
        },
        mounted(){
            const that = this;
            window.onresize = () => {
                return (() => {
                    that.screenHeight = window.innerHeight
                })()
            }
        },
        /**
         * 监听
         */
        watch: {
            // 监听 结束时间
            testPagingObj: {
                handler (newVal, oldVal) {
                    if (!oldVal) return false;

                    if (newVal.keywords != oldVal.keywords) {
                        this.getParamInfo();
                    }
                },
                immediate: false,
                deep: true
            },
        },
        /**
         * 计算
         */
        computed: {
            testPagingObj() {
                return JSON.parse(JSON.stringify(this.searchForm));
            }
        },
        /**
         * 方法定义
         */
        methods: {

            renderHeader(h, { column }) {
                const serviceContent= [

                    h(
                        "div",
                        {
                            slot: "content"
                        },
                        "点击参数值可进行参数值的编辑操作"
                    )
                ];

                return h("div", [
                    h("span", column.label),
                    h(
                        "el-tooltip",
                        {
                            props: {
                                placement: "bottom"
                            }
                        },
                        [
                            serviceContent,
                            h("i", {
                                class: "el-icon-warning-outline",
                                style: "color:orange;margin-left:5px;"
                            })
                        ]
                    )
                ]);
            },

            /**
             * 查询参数列表
             */
            getParamInfo() {
                this.$request.postJsonRequest(SystemParam.searchParam, {
                  projectId: this.$store.state.currentProjectId,
                  keywords: this.searchForm.keywords,
                }).then(res => {
                    if (res.rows) {
                        this.tableData = res.rows;
                    } else {
                        this.tableData = [];
                    }
                    this.tableData.forEach((row, index) => {
                        row.seen = false;
                        row.index = index;
                    });

                }).catch(error => {
					console.error('查询参数配置异常', SystemParam.searchParam, error);
                });
            },

            /**
             * 单元格点击事件
             * @param row
             * @param column
             * @param event
             * @param cell
             */
            cellEdit(row,column,a,b,c) {
                //console.log({row,column,a,b,c});

                if (column.property != 'paramValue') return false;
                // 将单元格变为输入框
                row.seen = true;
                this.$set(this.tableData,row.index,row);
                // 聚焦到单元格
                setTimeout(() => {
                    this.$refs[column.property] && this.$refs[column.property].focus();
                }, 20)
            },
            /**
             *当输入框失去焦点时不显示输入框
             */
            loseFocus(editCell) {
                editCell.seen = false;
                const paramId = editCell.paramId;
                const paramValue = editCell.paramValue;

                this.$request.postJsonRequest(SystemParam.updateParam, {
                  projectId: this.$store.state.currentProjectId,
                  paramId: paramId,
                  paramValue: paramValue
                }).then(res => {
                    this.getParamInfo();

                }).catch(error => {
					console.error('编辑参数配置异常', SystemParam.updateParam, error);
                })
            },
            /**
             * TODO 点击 switch开关 改变参数值
             */
            changeParamValue(row, index) {
              this.$request.postJsonRequest(SystemParam.updateParam, {
                projectId: this.$store.state.currentProjectId,
                paramId: row.paramId,
                paramValue: row.paramValue
              }).then(res => {
                    // 更改失败
                    if (res.code != 0) {
                    	row.paramValue = (row.paramValue == 'true' ? 'false' : 'true');
                    }else{
                      this.getParamInfo();
                    }
               }).catch(error => {
					console.error('编辑参数配置异常', SystemParam.updateParam, error);
               });
            },

        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/System/ParamConfig.vue